import { ZOD_ERROR_CODE } from "utils/constants";
import logger from "utils/logger";

class SchemaError extends Error {
  constructor(message: string, cause: any) {
    super(message);
    this.cause = cause;
    this.name = 'ApiSchemaError';
  }
}

function SchemaMismatchError(message: string, cause?: any) {
  let serialize = ""
  let isZodError = false
  try{
    throw new SchemaError(message, cause);
  }
  catch(err: any) {
    let { name, message: key = "", cause = "" } = err
    let message = `${name}: Failed parsing api schema`
    let path = `path: ${key}`
    cause = `errors: ${cause}`
    serialize = [ message, path, cause ].join("\n")

    // do not create a catch for the thrown error, or else it won't be known why the api is failing silently
    if(cause.includes(ZOD_ERROR_CODE)) {
      isZodError = true
      serialize = serialize.replace(`Error: ${ZOD_ERROR_CODE}\n`, "")
      throw new Error(serialize)
    }
  }
  finally{
    logger.noticeError(serialize, !isZodError)
  }
}

export default SchemaMismatchError